import { render, staticRenderFns } from "./extra-link-card.vue?vue&type=template&id=2f209f3a&scoped=true&lang=pug&"
import script from "./extra-link-card.vue?vue&type=script&lang=js&"
export * from "./extra-link-card.vue?vue&type=script&lang=js&"
import style0 from "./extra-link-card.vue?vue&type=style&index=0&id=2f209f3a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f209f3a",
  null
  
)

export default component.exports